import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { observer, inject } from "mobx-react";

import "./subscription.scss";
import Modal from "reactstrap/lib/Modal";
import { ModalHeader, ModalBody, Row, Col, Button, Alert } from "reactstrap";
import InnerHTML from "dangerously-set-html-content";
import { Spinner } from "reactstrap";
import { useTranslation } from "react-i18next";

const SubscriptionTrial: React.FC<any> = ({
  authStore,
  sessionStore,
  clientStore,
  guestStore,
  history,
}) => {
  const { t } = useTranslation();
  const location = useLocation().search;
  const [WelcomeScreenModal, setWelcomeScreenModal] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const redirectTouserflow = () => {
    if (
      clientStore?.clientInfo?.CustomTextField01?.length === 0 ||
      clientStore.familyMembers?.length === 0
    ) {
      history.push("/account");
      return;
    }
  };

  const redirectToDashboard = () => {
    if (
      clientStore?.clientInfo?.SessionCount > 0 &&
      sessionStore.activeSessionImages?.length > 0
    ) {
      history.push("/dashboard");
      return;
    }

    if (
      clientStore?.clientInfo?.SessionCount > 0 &&
      sessionStore.activeSessionImages?.length === 0
    ) {
      history.push("/dashboard");
      return;
    }

    if (
      clientStore?.clientInfo?.SessionCount === 0 ||
      (clientStore?.clientInfo?.SessionCount > 0 &&
        sessionStore.activeSessionImages?.length === 0)
    ) {
      history.push("/sessions-list");
      return;
    } else {
      history.push("/sessions-list");
    }
  };

  const checkTrialDate = () => {
    let today: any = new Date().toISOString().split(".")[0];

    let clientStatusDate = clientStore.statusDueDate;

    const expiredDate: any = new Date(clientStatusDate);
    const TodaysDate: any = new Date(today);

    let diffTime = Math.round(Math.abs(expiredDate - TodaysDate));

    const trialDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return trialDays;
  };

  const trialDaysRemaining = checkTrialDate();

  useEffect(() => {
    // Check for paymentStatus in url: usercanceled, approved, other
    const splitParams = location.substring(1).split("&");
    let paymentStatus = "";

    for (let param of splitParams) {
      if (param.includes("paymentStatus")) {
        paymentStatus = param.split("=")[1];
      }
      if (param.includes("bearer")) {
        // Set axios bearer token
        const bearer = param.split("=")[1];
        authStore.signup(
          authStore.signupResponse.SubscriptionPlanMaintKey,
          bearer
        );
        // axios.defaults.headers.common["Authorization"] = `Bearer ${bearer}`;
        return;
      }
    }
    if (!paymentStatus) return;
    if (paymentStatus === "usercanceled") {
      setErrorMessage("You did not complete the signup process");
      setTimeout(() => {
        setErrorMessage("");
      }, 6000);
    } else {
      // Something went wrong alert
      setErrorMessage("Something went wrong. Please try again");
      setTimeout(() => {
        setErrorMessage("");
      }, 6000);
    }
  }, []);

  const handleSubscribeClick = async () => {
    await authStore.signup(authStore.SubscriptionPlanMaintKey);
  };

  return (
    <>
      <Modal
        isOpen={WelcomeScreenModal}
        wrapClassName="modal-box"
        modalTransition={{ timeout: 500 }}
        backdropTransition={{ timeout: 0 }}
        centered
        size="lg"
        className="subscription-modal"
      >
        {errorMessage.length > 0 && (
          <Alert
            style={{
              position: "absolute",
              top: "25px",
              left: "50%",
              transform: "translateX(-50%)",
            }}
            color="danger"
          >
            {errorMessage}
          </Alert>
        )}
        <div className="subscription-popup">
          <ModalHeader className="header">Welcome</ModalHeader>
          <ModalBody>
            {authStore.signupResponse.ConfirmationHtml ? (
              <>
                <div className="info-graphics-image">
                  <img src="images/Baby_Background_Vignette.jpeg" alt="" />
                </div>
                <div className="welcome-text">
                  <p>
                    <InnerHTML
                      html={authStore.signupResponse.ConfirmationHtml}
                    />
                  </p>
                </div>
                <Row>
                  <Col>
                    <Button
                      color="primary text-truncate"
                      className="w-100"
                      onClick={() => {
                        setWelcomeScreenModal(false);
                      }}
                    >
                      Ok
                    </Button>
                  </Col>
                </Row>
              </>
            ) : (
              <>
                <div className="info-graphics-image">
                  <img src="images/Baby_Background_Vignette.jpeg" alt="" />
                </div>

                <div className="welcome-text">
                  <p>
                    Welcome to the 30 day free trial of the{" "}
                    {authStore.companyName}. You have{" "}
                    <span>{trialDaysRemaining}</span> days left in your free
                    trial.
                  </p>
                </div>

                <div className="welcome-sub-text">
                  <p>
                    <p>{t("SubscriptionPage.welcomeText")}</p>
                  </p>
                  <p>
                    <p>{t("SubscriptionPage.welcomeSubtext")}</p>
                  </p>
                </div>

                <div className="subscription-box mb-4">
                  <div className="subscription-text">
                    {authStore.monthlySubscriptionAmountFormatted}/month
                  </div>
                </div>
                <Row>
                  <Col>
                    <Button
                      color="primary text-truncate"
                      className="w-100"
                      onClick={handleSubscribeClick}
                    >
                      {authStore.isLoading ? (
                        <Spinner color="light" />
                      ) : (
                        "Subscribe Now"
                      )}
                    </Button>
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col>
                    <Button
                      color="secondary text-truncate"
                      className="w-100"
                      onClick={
                        authStore.userflowCreateAccount
                          ? redirectTouserflow
                          : redirectToDashboard
                      }
                    >
                      Continue with Free Trial
                    </Button>
                  </Col>
                </Row>
              </>
            )}
          </ModalBody>
        </div>
      </Modal>
    </>
  );
};

export default inject(
  "authStore",
  "sessionStore",
  "clientStore",
  "guestStore"
)(observer(SubscriptionTrial));
